import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/kurzy" as const,
	[Locale.en]: "/courses" as const,
} satisfies LocalizedString;

export function getCoursesListingPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
